import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, message, Button, Select } from 'antd'
import MyInput from '../../components/forms/input'
import MyRadio from '../../components/forms/radio'
import MyDatePicker from '../../components/forms/datePicker'

const EditPresentationSlot = (props) => {
    const { id, campus, slot_type, date, time_range, venue_id } = props.data

    const [formValue, setFormValue] = useState({
        event_slot_id: id,
        campus: campus,
        slot_type: slot_type,
        date: date,
        time_range: time_range,
        venue_id: venue_id
    })

    const [venueOptions, setVenueOptions] = useState([])
    const [errorMsg, setErrorMsg] = useState({})

    const getVenueList = (campus) => {
        axios.post('/admin/venue/list', {
            campus: campus,
            slot_type: 1,
            per_page: 1000
        }).then(res => {
            if (res.errcode === 0) {
                const list = res.data.list || []
                setVenueOptions(
                    list.map(item => ({
                        label: item.name,
                        value: item.id
                    }))
                )
            }
        })
    }

    useEffect(() => {
        if (formValue.campus) {
            getVenueList(formValue.campus)
        }
    }, [formValue.campus])

    const handleSubmit = () => {
        setErrorMsg({})

        if (!formValue.date) {
            setErrorMsg({ dateEmpty: '日期不能为空' })
            return false
        }

        if (formValue.slot_type === 1 && !formValue.time_range) {
            setErrorMsg({ timeRangeEmpty: '时间段不能为空' })
            return false
        }

        if (!formValue.venue_id) {
            setErrorMsg({ venueEmpty: '请选择场地' })
            return false
        }

        axios.post('/admin/event_slot/edit', {
            event_slot_id: formValue.event_slot_id,
            campus: formValue.campus,
            slot_type: formValue.slot_type,
            date: formValue.date,
            time_range: formValue.slot_type === 1 ? formValue.time_range : '',
            venue_id: formValue.venue_id
        })
        .then(function (response) {
            if (response.errcode === 0) {
                message.success('编辑成功！')
                props.getSlotData()
            } else if (response.errcode === 1) {
                message.error('编辑失败，此资源已存在', 5)
            }
        })
        .catch(function (error) {
            console.error('请求失败：', error)
        })
    }

    const handleOk = () => {
        const isOk = handleSubmit()
        if (isOk !== false) { handleCancel() }
    }

    const handleCancel = () => {
        setErrorMsg({})
        setFormValue({})
        props.isCancel()
    }

    return (
        <Modal
            title="编辑宣讲会资源"
            width='800px'
            open={props.isOpen}
            onCancel={handleCancel}
            maskClosable={false}
            footer={[
                <Button key='cancel' onClick={handleCancel}>取消</Button>,
                <Button key='ok' type="primary" onClick={handleOk}>保存</Button>
            ]}
        >

            <MyRadio
                id='campus'
                label='所属校区'
                options={[
                    { label: '兰州职业技术学院', value: 1 },
                    { label: '雁儿湾校区', value: 2 },
                    { label: '桃林校区', value: 3 }
                ]}
                defaultValue={1}
                value={formValue.campus}
                onChange={(updater) => {
                    setFormValue(prev => {
                        const next = updater(prev)
                        return {
                            ...next,
                            venue_id: ''
                        }
                    })
                }}
            />

            <MyDatePicker
                id="date"
                required
                label="日期"
                value={formValue.date}
                onChange={setFormValue}
                errorMsg={errorMsg.dateEmpty}
                styles={{ width: '100%' }}
            />

            <MyInput
                id="time_range"
                required
                label='时间段'
                placeholder='例如：09:00-10:00'
                value={formValue.time_range}
                onChange={setFormValue}
                errorMsg={errorMsg.timeRangeEmpty}
            />

            <div style={{ marginTop: 16 }}>
                <div>选择场地</div>
                <Select
                    style={{ width: '100%' }}
                    placeholder="请选择场地"
                    value={formValue.venue_id}
                    onChange={(val) => {
                        setFormValue({
                            ...formValue,
                            venue_id: val
                        })
                    }}
                    options={venueOptions}
                />
                <div style={{ color: 'red' }}>{errorMsg.venueEmpty}</div>
            </div>

        </Modal>
    )
}

export default EditPresentationSlot
